import NewLayout from "@components/new-ui/Layout";
import { CompanyTrustBanner } from "@components/Webinar/CompanyTrustBanner";
import IndividualWebinar, { IndividualWebinarProps } from "@components/Webinar/IndividualWebinar";

const HeroSectionData: IndividualWebinarProps = {
    title: "How India’s Top Real Estate Brands Use WhatsApp Differently",
    listHeading: `There's a reason some real estate brands are closing deals faster, booking more site visits, and barely missing a lead, while others are still stuck chasing callbacks.
The difference? They're not waiting around for phone calls and emails. They've moved the entire buyer journey to WhatsApp.`,
    listText: [
        { label: "Following up with leads instantly (without lifting a finger)" },
        { label: "Turning cold inquiries into booked visits with automated nudges" },
        { label: "Keeping sales teams on the same page, no messy Excel sheets" },
        { label: "Using WhatsApp to build real conversations, not just broadcast messages" },
    ],
    mediaUrl: "https://assets.gallabox.com/gb-home/webinar/webinar-8.png",
    speakerList: [
        {
            image: "/ranganayaki.png",
            name: "Ranganayaki R",
            role: "Whatsapp Evangelist",
        },
        {
            image: "/shoaib.png",
            name: "Shoaib Ahmed",
            role: "Growth Specialist",
        },
    ],
    youtubeURL: "https://youtu.be/ivPrvMam4Hw",
    inThisWebinar: "In this session, you'll learn how the fastest-growing developers and brokers in India are:",
    webinarSlug: "whatsapp-real-estate",
};

const Webinar: React.FC = () => {
    return (
        <NewLayout
            title="What India's fastest-growing real estate brands are doing differently with WhatsApp"
            description="From lead response to site visit reminders—see how top real estate brands are automating their WhatsApp sales process to close faster."
            canonical="https://gallabox.com/webinars/whatsapp-real-estate"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/webinar/webinar-8.png" }}
        >
            <IndividualWebinar {...HeroSectionData} />
            <CompanyTrustBanner />
        </NewLayout>
    );
};

export default Webinar;
